import React from 'react';
import incidentsData from './content/incidents';
import { Marker } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import L from 'leaflet';

export const Incidents = (props) => {
    const { label, incidents, id } = props;

    const createClusterCustom = (cluster) => {
        var childCount = cluster.getChildCount();

        return new L.DivIcon({
            html: '<div><span>' + childCount + '</span></div>',
            className: `marker-cluster marker-cluster--${id.toLowerCase()}`,
            iconSize: new L.Point(40, 40),
        });
    };

    const incidentIcon = new L.Icon({
        iconUrl: require(`../../images/marker-${id}.svg`),
    });

    return (
        <MarkerClusterGroup iconCreateFunction={createClusterCustom}>
            {incidents.map((coords, index) => {
                return <Marker key={index} position={coords} icon={incidentIcon}></Marker>;
            })}
        </MarkerClusterGroup>
    );
};
